'use strict';

export class Classification {
    constructor(
       public code: string,
       public categorie: string,
       public wording: string
    ) {}
}
